import { Injectable } from "@angular/core";

export type Dictionary = Record<string, number>;
export type PendingDictionary = Record<string, true>;

Injectable({
    providedIn: "root"
});
export class CompressService {

    static async CompressAccessToken(input: string | null): Promise<string> {
        if (input == null) {
            return "";
        }

        const sectionsToCompress = 2;
        return this.GenerateCompressedToken(input, sectionsToCompress);
    }

    static async CompressGzip(str: string): Promise<string> {
        const arrBuffer = new TextEncoder().encode(str);
        const stream = new Blob([arrBuffer]).stream();
        const compressedStream = stream.pipeThrough(new CompressionStream("gzip"));
        const compressedResponse = new Response(compressedStream);
        const blob = await compressedResponse.blob();
        const buffer = await blob.arrayBuffer();
        const bufferView = new Uint8Array(buffer);

        return encodeURI(btoa(String.fromCharCode(...bufferView)));
    }

    private static jwtDecode(token: string): string {
        token = token.replace(/-/g, "+").replace(/_/g, "/");
        switch (token.length % 4) {
            case 0:
                break;
            case 2:
                token += "==";
                break;
            case 3:
                token += "=";
                break;
            default:
                throw new Error("base64 string is not of the correct length");
        }

        return this.b64DecodeUnicode(token);
    }

    private static b64DecodeUnicode(str: string): string {
        return decodeURIComponent(
            atob(str).replace(/(.)/g, (m, p) => {
                let code = (p as string).charCodeAt(0).toString(16).toUpperCase();
                if (code.length < 2) {
                    code = `0${  code}`;
                }
                return `%${  code}`;
            })
        );
    }

    private static async GenerateCompressedToken(input: string, sectionsToCompress: number): Promise<string> {
        const tokenSections = input.split(".");
        const tokenDataToCompress = tokenSections.slice(0, sectionsToCompress);
        const tokenDataOther = tokenSections.slice(sectionsToCompress, tokenSections.length);

        const compressedData = await this.GenerateTokenPayload(tokenDataToCompress);
        const noneCompressedData = tokenDataOther.join(".");
        return `${compressedData}.${noneCompressedData}`;
    }

    private static async GenerateTokenPayload(tokenPayload: string[]): Promise<string> {
        const outputValues = [];
        tokenPayload.forEach(section => {
            const output = this.jwtDecode(section);
            outputValues.push(output);
        });

        return await this.CompressGzip(outputValues.join("."));
    }
}
